import React from 'react';
import { BREAKPOINT_LARGE } from '../../config';
import { useActions } from '../../state';
import css from './Banner.module.scss';
import { useMediaQuery } from '@mui/material';
import BondDoubleExtendedIcon from '../../assets/bond-double extended-grape-solid.svg';
import BondDoubleIcon from '../../assets/bond-double-purple-solid.svg';
import BondSingeIcon from '../../assets/bond-single-sand-solid.svg';
import CloseIcon from '../../assets/close.svg';
import { Button } from '../Button/Button';
import { useTranslation } from 'react-i18next';
import CarouselIcon from '../../assets/carousel-icon.svg';
interface BannerProps {
    title: string;
    description: string[];
    buttonText?: string;
    buttonLink?: string;
    image?: string;
    Icon?: React.FC<React.SVGAttributes<SVGElement>>;
}

export const Banner = ({ title, description, buttonText, buttonLink, image, Icon }: BannerProps): JSX.Element => {
    const { t } = useTranslation('Banner');
    const isMobile = useMediaQuery(BREAKPOINT_LARGE);
    const { closeBanner } = useActions();

    return (
        <>
            {isMobile ? (
                <div className={css.mobileBannerContainer}>
                    <Button variant="unstyled" onClick={closeBanner} className={css.closeButton}>
                        <CloseIcon />
                    </Button>
                    <div className={css.mobileBannerContentContainer}>
                        <div className={css.mobileBannerHeadText}>{t(title)}</div>
                        <div className={css.mobileBannerText}>
                            {description.map((text, index) => (
                                <p key={index}>{t(text)}</p>
                            ))}
                        </div>
                        <a className={css.openButton} href={buttonLink} target="_blank" rel="noreferrer">
                            <CarouselIcon />
                            {buttonText && t(buttonText)}
                        </a>
                    </div>
                    <div className={css.mobileBondsContainer}>
                        <div className={css.mobileExtendedBond}>
                            <BondDoubleExtendedIcon />
                        </div>
                        <div className={css.mobileDoubleBond}>
                            <BondDoubleIcon />
                        </div>
                        <div className={css.mobileSingleBond}>
                            <BondSingeIcon />
                        </div>
                    </div>
                </div>
            ) : (
                // Is not mobile
                <div className={css.bannerContainer}>
                    <Button variant="unstyled" onClick={closeBanner} className={css.closeButton}>
                        <CloseIcon />
                    </Button>
                    <div className={css.bannerImage}>
                        <img src={image} alt="Banner image" />
                    </div>
                    <div className={css.bannerContentContainer}>
                        <div className={css.bannerHeadText}>{t(title)}</div>
                        <div className={css.bannerText}>
                            {description.map((text, index) => (
                                <p key={index}>{t(text)}</p>
                            ))}
                        </div>
                        <a className={css.openButton} href={buttonLink} target="_blank" rel="noreferrer">
                            {Icon && <Icon />}
                            {buttonText && t(buttonText)}
                        </a>
                    </div>
                    <div className={css.bondsContainer}>
                        <div className={css.extendedBond}>
                            <BondDoubleExtendedIcon />
                        </div>
                        <div className={css.doubleBond}>
                            <BondDoubleIcon />
                        </div>
                        <div className={css.singleBond}>
                            <BondSingeIcon />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
